import React, { useContext, useMemo } from 'react';
import { AppContext } from '../Layout/Layout';

export default function UOMConversion({ UOMCode }) {
    const { ProductRelatedStates: { ProductsUOMDetails } } = useContext(AppContext);
    const UOM = useMemo(() => {
        return ProductsUOMDetails.Data.find(P =>
            P.Value === UOMCode
        )?.Description || ''
    }, [ProductsUOMDetails, UOMCode])
    return (
        <span>{UOM}</span>
    )
}
